import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter, useHistory, Redirect } from 'react-router-dom'
import { businessunitsActions } from '../../../actions/businessunitsActions'
import { routes } from '../../../constantes/routes'
import Search from '../../common/Search'
import PlusBtn from '../../buttons/PlusBtn'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import { onSubmitText } from '../../../constantes/onSubmitText'
import Header from '../../header/Header'
import validators from '../../../utils/validationsRegEx'
import { businessunitsTypes } from '../../../constantes/actionTypes'
import { swalMssgs } from '../../../constantes/swalMssgs'
import BusinessUnitsList from './BusinessUnitsList'
import EditBusinessUnitModal from './EditBusinessUnitModal'
import NewBusinessUnitModal from './NewBusinessUnitModal'

const BusinessUnitsContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const allBusinessUnits = useSelector((state) => state.businessunits)

  const [items, setItems] = useState(allBusinessUnits)

  const [newBusinessUnit, setNewBusinessUnit] = useState({})
  const [editBusinessUnit, setEditBusinessUnit] = useState({})
  const [modalIsOpen, setIsOpen] = useState({
    createModal: false,
    editModal: false,
  })

  const dispatch = useDispatch()
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const createBusinessUnit = (businessunit) =>
    dispatch(businessunitsActions.newBusinessUnit(businessunit))
  const updateBusinessUnit = (businessunit) =>
    dispatch(businessunitsActions.updateBusinessUnit(businessunit))
  const deleteBusinessUnit = (idBusinessUnit) =>
    dispatch(businessunitsActions.deleteBusinessUnit(idBusinessUnit))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getAllBusinessUnits()
    }
  }, [])

  useEffect(() => {
    setItems(allBusinessUnits)
  }, [allBusinessUnits])

  const openNewModal = () => {
    setNewBusinessUnit({})
    setIsOpen({
      createModal: true,
      editModal: false,
    })
  }

  const openEditModal = (businessunit) => {
    setEditBusinessUnit(businessunit)
    setIsOpen({
      createModal: false,
      editModal: true,
    })
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      const response = await createBusinessUnit(newBusinessUnit)
      if (businessunitsTypes.NEW_BUSINESSUNIT_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        getAllBusinessUnits()
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleSubmitUpdate = async (event) => {
    event.preventDefault()
    try {
      const response = await updateBusinessUnit(editBusinessUnit)
      // console.log('response', response)
      if (businessunitsTypes.UPDATE_BUSINESSUNIT_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
        getAllBusinessUnits()
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleRemove = async (idBusinessUnit) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar esta Unidad de Negocio? Se eliminaran todos los registros y permisos asociados.',
      )
      if (alert.isConfirmed) {
        const response = await deleteBusinessUnit(idBusinessUnit)

        if (businessunitsTypes.DELETE_BUSINESSUNIT_SUCCESS === response.type) {
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
          getAllBusinessUnits()
        }
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleChangeNewBusinessUnit = (e) => {
    let value = e.target.value
    const name = e.target.name
    setNewBusinessUnit({ ...newBusinessUnit, [name]: value })
  }

  const handleChangeEditBusinessUnit = (event) => {
    // console.log('event value', event.target.value)
    // console.log('event name', event.target.name)
    const value = event.target.value
    const name = event.target.name
    setEditBusinessUnit((editBusinessUnit) => ({
      ...editBusinessUnit,
      [name]: value,
    }))
    // console.log('editBusinessUnit', editBusinessUnit)
  }

  const validateFormNew = () => {
    return validators.hasValue(newBusinessUnit.nombre)
  }

  const validateFormEdit = () => {
    return validators.hasValue(editBusinessUnit.nombre)
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const onChangeSearch = (value) => {
    const newItems = allBusinessUnits.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Unidades de Negocio'}
            route={toBackoffice}
            backBtn={true}
          />
          <div className='filter__wrap mb-80'>
            <Search onChangeSearch={onChangeSearch} placeholder='Buscar...' />
            <div className='add__action__rigth__side'>
              <button className='action-button' onClick={openNewModal}>
                <PlusBtn />
                <span>Nueva Unidad de Negocio</span>
              </button>
            </div>
          </div>
          <BusinessUnitsList
            allBusinessUnits={items}
            handleRemove={handleRemove}
            openEditModal={openEditModal}
          />
          <NewBusinessUnitModal
            newBusinessUnit={newBusinessUnit}
            modalIsOpen={modalIsOpen.createModal}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
            handleChange={handleChangeNewBusinessUnit}
            validateForm={validateFormNew}
            textBtn={onSubmitText.Crear}
          />
          <EditBusinessUnitModal
            editBusinessUnit={editBusinessUnit}
            modalIsOpen={modalIsOpen.editModal}
            closeModal={closeModal}
            handleSubmit={handleSubmitUpdate}
            handleChange={handleChangeEditBusinessUnit}
            validateForm={validateFormEdit}
            textBtn={onSubmitText.Guardar}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(BusinessUnitsContainer)
